import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { formatDateTime } from '@utils/helpers/formatDate';

const columns = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: 'Seller Name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Seller E-mail Address',
    dataIndex: 'email',
    key: 'email'
  },
  {
    title: 'Buyer Name',
    dataIndex: 'buyerName',
    key: 'buyerName'
  },
  {
    title: 'Order Number',
    dataIndex: 'orderNumber',
    key: 'orderNumber'
  },
  {
    title: 'Status ',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: 'Update Date',
    render: (record: any) => {
      return formatDateTime(record.updatedAt);
    }
  }
];

interface IProps {
  loading: boolean;
  totalDeliveries: number;
  deliveriesRowData: any;
  selectedDeliveries: React.Key[];
  handleChangePage: Function;
  page: number;
  setSelectedDeliveries: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const ShippingListTable = ({
  loading,
  totalDeliveries,
  deliveriesRowData,
  selectedDeliveries,
  page,
  handleChangePage,
  setSelectedDeliveries
}: IProps) => {
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedDeliveries(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedDeliveries,
    onChange: onSelectChange
  };

  return (
    <div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        loading={loading}
        columns={columns}
        dataSource={deliveriesRowData}
        pagination={{
          pageSize: 10,
          total: totalDeliveries,
          current: page,
          onChange: (newPage) => {
            handleChangePage(newPage);
          }
        }}
      />
    </div>
  );
};

export default ShippingListTable;
